import { faXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { components, MultiValueRemoveProps } from 'react-select';

import { OptionType } from 'interfaces/shared.interface';

const MultiSelectValueRemoveButton = (props: MultiValueRemoveProps<OptionType>) => {
  return (
    components.MultiValueRemove && (
      <components.MultiValueRemove {...props}>
        <FontAwesomeIcon className="dark:text-white text-gray2 px-1 cursor-pointer" icon={faXmark} />
      </components.MultiValueRemove>
    )
  );
};
export default MultiSelectValueRemoveButton;
